function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna Cheppudira 2013.
// Co-author: Benjamin W. Bohl
//
// ## Description
//
// This file implements various types of clefs that can be rendered on a stave.
//
// See `tests/clef_tests.js` for usage examples.
import { Vex } from './vex';
import { StaveModifier } from './stavemodifier';
import { Glyph } from './glyph'; // To enable logging for this class, set `Vex.Flow.Clef.DEBUG` to `true`.

function L() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (Clef.DEBUG) Vex.L('Vex.Flow.Clef', args);
}

export var Clef = /*#__PURE__*/function (_StaveModifier) {
  _inherits(Clef, _StaveModifier);

  var _super = _createSuper(Clef);

  _createClass(Clef, null, [{
    key: "CATEGORY",
    get: function get() {
      return 'clefs';
    } // Every clef name is associated with a glyph code from the font file
    // and a default stave line number.

  }, {
    key: "types",
    get: function get() {
      return {
        'treble': {
          code: 'gClef',
          line: 3
        },
        'bass': {
          code: 'fClef',
          line: 1
        },
        'alto': {
          code: 'cClef',
          line: 2
        },
        'tenor': {
          code: 'cClef',
          line: 1
        },
        'percussion': {
          code: 'restMaxima',
          line: 2
        },
        'soprano': {
          code: 'cClef',
          line: 4
        },
        'mezzo-soprano': {
          code: 'cClef',
          line: 3
        },
        'baritone-c': {
          code: 'cClef',
          line: 0
        },
        'baritone-f': {
          code: 'fClef',
          line: 2
        },
        'subbass': {
          code: 'fClef',
          line: 0
        },
        'french': {
          code: 'gClef',
          line: 4
        },
        'tab': {
          code: '6stringTabClef'
        }
      };
    } // Create a new clef. The parameter `clef` must be a key from
    // `Clef.types`.

  }]);

  function Clef(type, size, annotation) {
    var _this;

    _classCallCheck(this, Clef);

    _this = _super.call(this);

    _this.setAttribute('type', 'Clef');

    _this.setPosition(StaveModifier.Position.BEGIN);

    _this.setType(type, size, annotation);

    _this.setWidth(_this.musicFont.lookupMetric("clef.".concat(_this.size, ".width")));

    L('Creating clef:', type);
    return _this;
  }

  _createClass(Clef, [{
    key: "getCategory",
    value: function getCategory() {
      return Clef.CATEGORY;
    }
  }, {
    key: "setType",
    value: function setType(type, size, annotation) {
      this.type = type;
      this.clef = Clef.types[type];

      if (size === undefined) {
        this.size = 'default';
      } else {
        this.size = size;
      }

      this.clef.point = this.musicFont.lookupMetric("clef.".concat(this.size, ".point"), 0);
      this.glyph = new Glyph(this.clef.code, this.clef.point, {
        category: "clef.".concat(this.clef.code, ".").concat(this.size)
      }); // If an annotation, such as 8va, is specified, add it to the Clef object.

      if (annotation !== undefined) {
        var code = this.musicFont.lookupMetric("clef.annotations.".concat(annotation, ".smuflCode"));
        var point = this.musicFont.lookupMetric("clef.annotations.".concat(annotation, ".").concat(this.size, ".point"));
        var line = this.musicFont.lookupMetric("clef.annotations.".concat(annotation, ".").concat(this.size, ".").concat(this.type, ".line"));
        var x_shift = this.musicFont.lookupMetric("clef.annotations.".concat(annotation, ".").concat(this.size, ".").concat(this.type, ".shiftX"));
        this.annotation = {
          code: code,
          point: point,
          line: line,
          x_shift: x_shift
        };
        this.attachment = new Glyph(this.annotation.code, this.annotation.point);
        this.attachment.metrics.x_max = 0;
        this.attachment.setXShift(this.annotation.x_shift);
      } else {
        this.annotation = undefined;
      }

      return this;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      if (this.type === 'tab' && !this.stave) {
        throw new Vex.RERR('ClefError', "Can't get width without stave.");
      }

      return this.width;
    }
  }, {
    key: "setStave",
    value: function setStave(stave) {
      this.stave = stave;
      if (this.type !== 'tab') return this;
      var numLines = this.stave.getOptions().num_lines;
      var point = this.musicFont.lookupMetric("clef.lineCount.".concat(numLines, ".point"));
      var shiftY = this.musicFont.lookupMetric("clef.lineCount.".concat(numLines, ".shiftY"));
      this.glyph.setPoint(point);
      this.glyph.setYShift(shiftY);
      return this;
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this.x) throw new Vex.RERR('ClefError', "Can't draw clef without x.");
      if (!this.stave) throw new Vex.RERR('ClefError', "Can't draw clef without stave.");
      this.setRendered();
      this.glyph.setStave(this.stave);
      this.glyph.setContext(this.stave.context);

      if (this.clef.line !== undefined) {
        this.placeGlyphOnLine(this.glyph, this.stave, this.clef.line);
      }

      this.glyph.renderToStave(this.x);

      if (this.annotation !== undefined) {
        this.placeGlyphOnLine(this.attachment, this.stave, this.annotation.line);
        this.attachment.setStave(this.stave);
        this.attachment.setContext(this.stave.context);
        this.attachment.renderToStave(this.x);
      }
    }
  }]);

  return Clef;
}(StaveModifier);